<template>
  <div class="recommend">
    <div class="tips">医生已为您推荐了以下商品</div>
    <order-list v-model="checked" :orderList="orderList" ref="drugOrederList" :expire="expire"></order-list>
    <van-empty
      v-if="!orderList.length && !load"
      description="暂无商品"
      image="https://static.91jkys.com/attachment/20210428105356694_a8c6c937d65640aaae9cf82b8c4af801.png"
    ></van-empty>
    <fixed-bottom
      v-show="!expire"
      :checked="checked"
      :totalCountPrice="totalCountPrice"
      @handleCheckAll="handleCheckAll"
      ref="fixedBottom"
      @submit="submit"
    ></fixed-bottom>
  </div>
</template>
<script>
import FixedBottom from './components/fixedBottom';
import OrderList from './components/orderList';
import jumpCenter from '@/mixins/jumpCenter';

export default {
  mixins: [jumpCenter],
  components: {
    FixedBottom,
    OrderList
  },
  data() {
    return {
      orderList: [],
      load: false,
      expire: false,
      checked: [] // 购物车选中
    };
  },
  computed: {
    totalCountPrice() {
      return this.orderList.reduce(
        (pre, cur) => (this.checked.indexOf(cur.itemId) !== -1 ? pre + cur.realPrice * cur.amount : pre),
        0
      );
    }
  },
  watch: {
    checked() {
      const len = this.orderList.filter((item) => item.stockNum && !item.status).length;
      if (len) this.$refs.fixedBottom.checkedAll = !!(this.checked.length === len);
    }
  },
  created() {
    this.fetchCartList();
    const { recommendId } = this.$route.query;
    const timeStamp = new Date().getTime();
    Telescope.trackEvent({ trackId: 'zyyd-click-fytjd', custom: { recommendId, timeStamp } });
  },
  methods: {
    handleCheckAll(checkedAll) {
      if (!this.$refs.drugOrederList) return;
      const len = this.orderList.filter((item) => item.stockNum && !item.status).length;
      if (checkedAll) {
        this.$refs.drugOrederList.toggleAll(checkedAll);
      } else {
        if (this.checked.length === len) this.$refs.drugOrederList.toggleAll();
      }
    },
    async fetchCartList() {
      this.load = true;
      const { recommendId } = this.$route.query;
      const { detailDTOList, expire, toastMsg } = await this.$fetch.fetchGetRecommendList({ recommendId });
      this.orderList = detailDTOList;
      if (expire) {
        this.load = false;
        this.expire = expire;
        this.$toast(toastMsg);
        return;
      }
      this.$nextTick(() => {
        this.$refs.drugOrederList.toggleAll(true);
      });
      this.load = false;
    },

    submit() {
      const { recommendId } = this.$route.query;

      const detail = this.orderList.filter((item) => this.checked.indexOf(item.itemId) !== -1);

      this.$fetch.fetchSubmitRecommendList({ recommendId, detailDTOList: detail }).then((res) => {
        const { canBuy, detailDTOList, doctorId, toastMsg } = res;
        if (canBuy) {
          this.saveDataAndToPreOrder({
            doctorId,
            recommendId,
            isDrug: '0',
            bizType: 'recommend',
            bizId: recommendId
          });
          // this.requestPreOrderAndJumpToPlaceOrder(
          //   { orders: detail, bizType: 'recommend', bizId: recommendId },
          //   { doctorId, recommendId, isDrug: '0' }
          // );
        } else {
          this.orderList = detailDTOList;
          this.$toast(toastMsg);
          this.$nextTick(() => {
            const item = this.orderList.filter((item) => item.amount !== item.itemNum || item.status === 1)[0];
            if (item) this.$refs.drugOrederList.scrollIntoView(item.itemId);
            const len = this.orderList.filter((item) => item.stockNum && !item.status).length;
            if (len) this.$refs.fixedBottom.checkedAll = true;
            this.$refs.drugOrederList.toggleAll(true);
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.recommend {
  .tips {
    background: #fff;
    font-size: 14px;
    height: 38px;
    line-height: 38px;
    padding: 0 16px;
    color: #8c8c8c;
  }
}
</style>
